import {
  USER_ROLES,
} from './constants';
import {
  ADDONS,
} from './constants/addons';

interface FeatureUser {
  id?: string | number;
  role?: string;
  isCustomer?: boolean;
  isStaff?: boolean;
  isSalesperson?: boolean;
  isAdmin?: boolean;
  relatedSalespersonId?: string | number;
}

function getCanAdd(currentUser: FeatureUser, targetUser: FeatureUser): boolean {
  if (currentUser.isCustomer) {
    // customer cannot create any user
    return false;
  }

  if (currentUser.isStaff && targetUser.role !== USER_ROLES.CUSTOMER) {
    // staff only can create customer
    return false;
  }

  if (currentUser.isSalesperson && targetUser.role !== USER_ROLES.CUSTOMER) {
    // salesperson only can create customer
    return false;
  }

  if (!currentUser.isAdmin
    && !currentUser.isStaff
    && !currentUser.isSalesperson
    && !currentUser.isCustomer
  ) {
    // unknown role
    return false;
  }

  // admin can add all
  return true;
}

function getCanEdit(currentUser: FeatureUser, targetUser: FeatureUser): boolean {
  if (currentUser.isCustomer && targetUser.id !== currentUser.id) {
    // customer only can edit self
    return false;
  }
  if (currentUser.isStaff && targetUser.role !== USER_ROLES.CUSTOMER) {
    // staff only can edit customer
    return false;
  }

  if (currentUser.isSalesperson
    && targetUser.relatedSalespersonId !== currentUser.id) {
    // salesperson only can edit customer be assigned
    return false;
  }

  if (!currentUser.isAdmin
    && !currentUser.isStaff
    && !currentUser.isSalesperson
    && !currentUser.isCustomer
  ) {
    // unknown role
    return false;
  }

  // admin can edit all
  return true;
}

function getCanDelete(currentUser: FeatureUser, targetUser: FeatureUser): boolean {
  if (currentUser.isAdmin && currentUser.id !== targetUser.id) {
    // only admin can delete
    return true;
  }

  return false;
}

function getCanEditStatus(currentUser: FeatureUser, targetUser: unknown): boolean {
  if ((currentUser.isAdmin || currentUser.isStaff) && targetUser === USER_ROLES.CUSTOMER) {
    return true;
  }

  return false;
}

// returns available role list for user list
// admin can create admin,staff,customer
// staff only can create customer
function getRoleList(currentUser: FeatureUser, subscriptions: Subscriptions): string[] {
  if (currentUser.isAdmin) {
    // TODO extract function
    if (subscriptions.available[ADDONS.SALESPERSON]) {
      return [
        'Customer',
        'Salesperson',
        'Staff',
        'Admin',
      ];
    }

    return [
      'Customer',
      'Staff',
      'Admin',
    ];
  }

  if (currentUser.isSalesperson) {
    return ['Customer'];
  }

  if (currentUser.isStaff) {
    return ['Customer'];
  }

  return [];
}

export {
  getCanAdd,
  getCanEdit,
  getCanEditStatus,
  getCanDelete,
  getRoleList,
};
